import { Injectable } from "@angular/core";
import { Http, Headers, RequestOptions } from "@angular/http";
import "rxjs/add/operator/map";
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";

@Injectable()
export class SharedService {
  constructor(private http: Http) {}

  private NotificationsCount = new Subject<any>();

  changeEmittedForNotificationsCount$ = this.NotificationsCount.asObservable();

  changeNotificationsCount(value) {
    this.NotificationsCount.next(value);
  }
}
